import React from 'react';
import styled from 'styled-components';
import { formatSaldo } from '../../utils/formatters';
import { theme } from '../../config/theme';

const Card = styled.div`
  background-color: ${props => props.theme.colors.surface};
  padding: 1.5rem;
  border-radius: ${props => props.theme.borderRadius};
  box-shadow: ${props => props.theme.shadows.soft};
  min-width: 0;
  height: 100%;
  box-sizing: border-box;
`;
const CardTitle = styled.h3`
  margin: 0 0 0.75rem 0;
  font-size: 1rem;
  font-weight: 600;
  color: ${props => props.theme.colors.textSecondary};
`;
const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
  th, td {
    padding: 0.5rem 0.25rem;
    border-bottom: 1px solid ${props => props.theme.colors.border};
    text-align: left;
    vertical-align: top;
  }
  td:last-child, th:last-child {
    text-align: right;
    white-space: nowrap;
  }
  tr:last-child td { border-bottom: none; font-weight: 700; }
  tbody tr.clickable { cursor: pointer; }
  tbody tr.clickable:hover td { background-color: ${props => props.theme.colors.background}; }
`;
const Detail = styled.span`
  display: block;
  font-size: 0.75rem;
  font-weight: 400;
  color: ${props => props.theme.colors.textSecondary};
`;
const EmptyText = styled.p`
  margin: 0;
  font-size: 0.85rem;
  color: ${props => props.theme.colors.textSecondary};
`;

const netoColor = (neto) => {
  if (neto > 0) return theme.colors.success.replace('0.15', '1');
  if (neto < 0) return theme.colors.errorText;
  return theme.colors.secondary;
};

const MovimientosDelDiaCard = ({ desglose, currency, onSelectCategoria }) => {
  const format = (value) => formatSaldo(value, currency);
  const { cauciones, operacionesCI, ingresosEgresos, fci, totalNeto } = desglose;
  // pases puede faltar en un desglose viejo/cacheado: se protege con un default.
  const pases = desglose.pases || { tomadoras: 0, colocadoras: 0, neto: 0, cantidad: 0, items: [] };
  const licitaciones = desglose.licitaciones || { debitos: 0, neto: 0, cantidad: 0, items: [] };
  const sinMovimientos = cauciones.cantidad + pases.cantidad + operacionesCI.cantidad
    + ingresosEgresos.cantidad + fci.cantidad + licitaciones.cantidad === 0;

  const rows = [
    { key: 'cauciones', label: 'Cauciones', detail: `Tomadoras ${format(cauciones.tomadoras)} · Colocadoras ${format(cauciones.colocadoras)}`, agg: cauciones },
    { key: 'pases', label: 'Pases', detail: `Tomadoras ${format(pases.tomadoras)} · Colocadoras ${format(pases.colocadoras)}`, agg: pases },
    { key: 'operacionesCI', label: 'Operaciones C.I.', detail: `Ventas ${format(operacionesCI.ventas)} · Compras ${format(operacionesCI.compras)}`, agg: operacionesCI },
    { key: 'ingresosEgresos', label: 'Ingresos y egresos', detail: `Ingresos ${format(ingresosEgresos.ingresos)} · Egresos ${format(ingresosEgresos.egresos)}`, agg: ingresosEgresos },
    { key: 'fci', label: 'FCI', detail: `Rescates ${format(fci.rescates)} · Suscripciones ${format(fci.suscripciones)}`, agg: fci },
    { key: 'licitaciones', label: 'Licitaciones', detail: `Adjudicado a pagar ${format(licitaciones.debitos)}`, agg: licitaciones },
  ];

  const clickable = !!onSelectCategoria;
  const rowProps = (key) => clickable
    ? { className: 'clickable', onClick: () => onSelectCategoria(key), title: 'Click para ver detalle' }
    : {};

  return (
    <Card>
      <CardTitle>Movimientos del día (ejecutados)</CardTitle>
      {sinMovimientos ? (
        <EmptyText>Sin movimientos ejecutados hoy.</EmptyText>
      ) : (
        <Table>
          <thead>
            <tr><th>Tipo</th><th>Cant.</th><th>Neto</th></tr>
          </thead>
          <tbody>
            {rows.map(({ key, label, detail, agg }) => (
              <tr key={key} {...rowProps(key)}>
                <td>{label}<Detail>{detail}</Detail></td>
                <td>{agg.cantidad}</td>
                <td style={{ color: netoColor(agg.neto) }}>{format(agg.neto)}</td>
              </tr>
            ))}
            <tr {...rowProps('total')}>
              <td>Total</td>
              <td>{rows.reduce((acc, r) => acc + r.agg.cantidad, 0)}</td>
              <td style={{ color: netoColor(totalNeto) }}>{format(totalNeto)}</td>
            </tr>
          </tbody>
        </Table>
      )}
    </Card>
  );
};

export default MovimientosDelDiaCard;
